import React, { useState } from 'react';
import './Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo */}
        <div className="navbar-logo">
          <img src="/logo.webp" alt="Logo" className="logo-image" />
        </div>

        {/* Menu Desktop */}
        <ul className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
          <li className="navbar-item">
            <button 
              className="navbar-link" 
              onClick={() => scrollToSection('inicio')}
            >
              INÍCIO
            </button>
          </li>
          <li className="navbar-item">
            <button 
              className="navbar-link" 
              onClick={() => scrollToSection('catalogo')}
            >
              CATÁLOGO
            </button>
          </li>
          <li className="navbar-item">
            <button 
              className="navbar-link" 
              onClick={() => scrollToSection('sobre-nos')}
            >
              SOBRE NÓS
            </button>
          </li>
          <li className="navbar-item">
            <button 
              className="navbar-link" 
              onClick={() => scrollToSection('contatos')}
            >
              CONTATOS
            </button>
          </li>
        </ul>

        {/* Menu Mobile Toggle */}
        <div className="navbar-toggle" onClick={toggleMenu}>
          <span className={`bar ${isMenuOpen ? 'active' : ''}`}></span>
          <span className={`bar ${isMenuOpen ? 'active' : ''}`}></span>
          <span className={`bar ${isMenuOpen ? 'active' : ''}`}></span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
